import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@storable/canaveral-components';
import { Col, Row } from 'react-bootstrap';
import { INPUT_PERMITTED_IMAGES_TYPES, resolveLogoUrl } from '../../../modules/assets';
import FormFieldLabel from '../FormFieldLabel';
import FormFieldMediumRow from '../../containers/FormFieldMediumRow';
import styles from './styles.scss';
import DefaultPrimaryImageForm from '../DefaultPrimaryImageForm';

const propTypes = {
  activeSection: PropTypes.string.isRequired,
  setActiveSection: PropTypes.func.isRequired,
  description: PropTypes.string,
  emptyMessage: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  })),
  loading: PropTypes.bool,
  mediumId: PropTypes.string,
  mediumField: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  setShowMediaGallery: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  setUsedMedia: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  description: undefined,
  errors: undefined,
  mediumId: undefined,
  loading: undefined,
};

const UploadMediumButtons = ({
  activeSection,
  description,
  emptyMessage,
  errors,
  mediumId,
  mediumField,
  loading,
  onUpload,
  setActiveSection,
  setShowMediaGallery,
  setErrors,
  setUsedMedia,
  title,
  ...rest
}) => {
  const uploadRef = useRef();
  const showGallery = () => {
    setActiveSection(activeSection);
    setErrors();
    setShowMediaGallery(true);
    setUsedMedia(mediumId ? [mediumId] : []);
  };

  return (
    <div>
      <Col xs={12} className={styles.buttonRow}>
        <FormFieldLabel title={title} description={description} />
        <input
          accept={INPUT_PERMITTED_IMAGES_TYPES}
          className={styles.uploadInput}
          ref={uploadRef}
          type="file"
          onChange={onUpload}
        />
        <Button
          className={styles.button}
          context="neutral"
          disabled={loading}
          icon="upload"
          onClick={() => uploadRef.current.click()}
        >
          Upload Image
        </Button>
        <Button
          className={styles.button}
          context="neutral"
          disabled={loading}
          icon="images"
          onClick={showGallery}
        >
          Select from Gallery
        </Button>
      </Col>
      {errors && (
        <Col xs={12}>
          <Alert context="danger">
            {errors.map(updateError => (
              <div key={updateError.code}>
                {updateError.message}
              </div>
            ))}
          </Alert>
        </Col>
      )}
      {mediumId && (
        <FormFieldMediumRow {...rest} mediumId={mediumId} />
      )}
      {!mediumId && mediumField === 'primaryImageMediumId' && (
        <DefaultPrimaryImageForm
          {...rest}
        />
      )}
      {!mediumId && mediumField !== 'primaryImageMediumId' && (
        <Row>
          <Col xs={5}>
            <img
              src={resolveLogoUrl()}
              alt="fallback logo"
              className={styles.defaultImage}
            />
          </Col>
          <Col xs={7}>
            <Alert context="info">
              {emptyMessage}
            </Alert>
          </Col>
        </Row>
      )}
    </div>
  );
};

UploadMediumButtons.propTypes = propTypes;
UploadMediumButtons.defaultProps = defaultProps;

export default UploadMediumButtons;
